import { ReactNode } from 'react';

import { Design, DesignHovered } from '@/components/confluence/icons/design';
import { Finance, FinanceHovered } from '@/components/confluence/icons/finance';
import { Hr, HrHovered } from '@/components/confluence/icons/hr';
import { Marketing, MarketingHovered } from '@/components/confluence/icons/marketing';
import {
	ProductManagement,
	ProductManagementHovered,
} from '@/components/confluence/icons/product-management';
import {
	ProjectManagement,
	ProjectManagementHovered,
} from '@/components/confluence/icons/project-management';
import { Recommended, RecommendedHovered } from '@/components/confluence/icons/recommended';
import { Software, SoftwareHovered } from '@/components/confluence/icons/software';
import { CategoryKey } from '@/templates/software/confluence/templates/confluence-templates-page/src/config/category-template-order.ts';

export interface IconPair {
	icon: ReactNode;
	iconHovered: ReactNode;
}

export function getIcons(key: CategoryKey): IconPair {
	switch (key) {
		case 'recommended':
			return {
				icon: <Recommended />,
				iconHovered: <RecommendedHovered />,
			};

		case 'project-management':
			return {
				icon: <ProjectManagement />,
				iconHovered: <ProjectManagementHovered />,
			};

		case 'software-development-and-it':
			return {
				icon: <Software />,
				iconHovered: <SoftwareHovered />,
			};

		case 'product-management':
			return {
				icon: <ProductManagement />,
				iconHovered: <ProductManagementHovered />,
			};

		case 'marketing-and-sales':
			return {
				icon: <Marketing />,
				iconHovered: <MarketingHovered />,
			};

		case 'design':
			return {
				icon: <Design />,
				iconHovered: <DesignHovered />,
			};

		case 'finance-and-operations':
			return {
				icon: <Finance />,
				iconHovered: <FinanceHovered />,
			};

		case 'human-resources':
			return {
				icon: <Hr />,
				iconHovered: <HrHovered />,
			};

		default:
			return {
				icon: <Design />,
				iconHovered: <DesignHovered />,
			} as never;
	}
}
